export default "__VITE_ASSET__bd5c1ea9__"